// Small status pill for the TopBar — shows online / offline / degraded.
import { Wifi, WifiOff, AlertTriangle } from "lucide-react";
import { useNetworkStatus } from "@/hooks/useNetworkStatus";
import {
  Tooltip, TooltipContent, TooltipProvider, TooltipTrigger,
} from "@/components/ui/tooltip";

export function NetworkStatus() {
  const { online, backendOk, lastCheck } = useNetworkStatus();
  const status = !online ? "offline" : backendOk ? "online" : "degraded";
  const cfg = {
    online:   { Icon: Wifi,       cls: "text-emerald-600",  label: "Bağlı",     tip: "Sunucu ve internet erişimi normal." },
    offline:  { Icon: WifiOff,    cls: "text-red-500",      label: "Çevrimdışı", tip: "İnternet bağlantısı yok. Son verilerden gösteriliyor." },
    degraded: { Icon: AlertTriangle, cls: "text-amber-500", label: "Sunucu?",   tip: "İnternet var ama sunucu yanıt vermiyor." },
  }[status];
  const { Icon, cls, label, tip } = cfg;
  const check = lastCheck ? lastCheck.toLocaleTimeString("tr-TR") : "—";

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div
            data-testid={`network-status-${status}`}
            className={`flex items-center gap-1.5 h-9 px-2 rounded-md hover:bg-muted transition-colors cursor-help ${cls}`}
          >
            <Icon className="h-4 w-4" />
            <span className="hidden md:inline text-xs font-medium">{label}</span>
          </div>
        </TooltipTrigger>
        <TooltipContent side="bottom">
          <div className="text-xs">
            <div>{tip}</div>
            <div className="text-muted-foreground mt-0.5">Son kontrol: {check}</div>
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
